export const enum categoryConstants  {
  
  //Get Category
  getCategoryRequest = "GET_CATEGORY_REQUEST",
  getCategorySuccess = "GET_CATEGORY_SUCCESS",
  getCategoryFailure = "GET_CATEGORY_FAILURE",

  categoryCreateRequest = "CATEGORY_CREATE_REQUEST",
  categoryCreateSuccess = "CATEGORY_CREATE_SUCCESS",
  categoryCreateFailure = "CATEGORY_CREATE_FAILURE",

  categoryToggleRequest = "CATEGORY_TOGGLE_REQUEST",
  categoryToggleSuccess = "CATEGORY_TOGGLE_SUCCESS",
  categoryToggleFailure = "CATEGORY_TOGGLE_FAILURE",

  getCategoryParamsRequest = "GET_CATEGORY_PARAMS_REQUEST",
  getCategoryParamsSuccess = "GET_CATEGORY_PARAMS_SUCCESS",
  getCategoryParamsFailure = "GET_CATEGORY_PARAMS_FAILURE",

  categoryDeleteRequest = "CATEGORY_DELETE_REQUEST",
  categoryDeleteSuccess = "CATEGORY_DELETE_SUCCESS",
  categoryDeleteFailure = "CATEGORY_DELETE_FAILURE",

  categoryViewRequest = "CATEGORY_VIEW_REQUEST",
  categoryViewSuccess = "CATEGORY_VIEW_SUCCESS",
  categoryViewFailure = "CATEGORY_VIEW_FAILURE",

};